import React from 'react';
import { useScrollTrigger } from '../lib/useScrollTrigger';

interface Props {
  onEnter: () => void;
  threshold?: number;
  triggerOnce?: boolean;
  className?: string;
  children?: React.ReactNode;
}

export const ScrollTrigger: React.FC<Props> = ({
  onEnter,
  threshold = 0.2,
  triggerOnce = false,
  className,
  children,
}) => {
  const ref = useScrollTrigger({ onEnter, threshold, triggerOnce });

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
};
